import { FunctionComponent } from 'react';
import { DisplayResult } from './DisplayResult';

export const DisplayListResult: FunctionComponent<{ values: unknown[] }> = ({ values }) => {
    const lastIndex = values.length - 1;
    return (
        <div className="display-flex flex-row flex-wrap gap-5">
            {values.map((value, index) => (
                <span key={`item-${index}`}>
                    <span className="bg-lightest padding-3 rounded">
                        <DisplayResult value={value} />
                    </span>
                    {index !== lastIndex && <span className="text-color-gray">, </span>}
                </span>
            ))}
        </div>
    );
};
